import axios from 'axios'
import { Tree } from 'vue-tree-list'
// import store from './index'

export default {
	namespaced: true,
	state: {
        loadingCurrentSystemId: false,
		tree_data: null,
		query_properties: null,
		new_item: null,
		humans: null,
		node: null,
		files: null,
		content: '',
		system_data: null,
		currentSystemId: null,
		mediaArr: [],
		search_items: [],
		systems: [],
		systems_copy: [],
		key: 0,
		curent_system: null,
		curent_tree: [],
		human_data: null,
		image_url: null,
		humans_autocomplite: [],
		headList: [],
		analyzers: [],
        loadingRedactor: false
	},
	getters: {
		getLoadingCurrentSystemId: state => state.loadingCurrentSystemId,
		getCurrentSystemId: state => state.currentSystemId,
		getKey: state => state.key,
		getImageUrl:state => state.image_url,
		currentNode: state => state.node,
		curentTree: state => state.curent_tree,
		curentSystem: state => state.curent_system,
		getQueryProperties: state => state.query_properties,
		getContent: state => state.content,
		getSystems: state => state.systems,
		systemsCopy: state => state.systems_copy,
		getSystemData: state => state.system_data,
		treeData: state => state.tree_data,
		metodistHumanData: state => state.human_data,
		humanData: state => state.humans,
		getSearch: state => state.search_items,
		getSearchHumans: state => state.humans_autocomplite,
		mediaFileIds: state => state.mediaArr,
		getHeadList: state => state.headList,
		analyzers: state => state.analyzers,
        getLoadingRedactor: state => state.loadingRedactor
	},
	mutations: {
        changeFlagConstructor(state, object) {
            state[object.name] = object.value;
        },
        changeLoadRedactor(state, value) {
            state.loadingRedactor = value;
        },
		changeCurrentSystemId(state, id) {
			state.currentSystemId = id;
		},
		setCurentTree(state, data) {
			let topItem = data.find((x) => x.itemType === 0);
			state.curent_tree = topItem;
		},
		falseActive(state, node) {
			function activeNode(items, node) {
				items.map(item => {
					item.active = false
					if (node.id === item.id) item.active = true
					if (item.children) activeNode(item.children, node)
				})
			}
			activeNode(state.curent_system.children, node)
		},
		setHeadList(state, arr) {
			state.headList = arr
		},
		setCurentSystem(state, systemIndex) {

			function activeNode(items, node) {
				items.map(item => {
					item.active = false
					if (node.id === item.id) item.active = true
					if (item.children) activeNode(item.children, node)
				})
			}
			activeNode(state.curent_tree.children, state.curent_tree.children[0])
			const system = state.curent_tree.children[systemIndex]
			state.systems = []
			system.editNodeDisabled = true
			system.delNodeDisabled = true
			state.curent_system = new Tree([system])
			// console.log(state.curent_system)
			state.curent_tree.children.forEach((item, i) => {
				state.systems.push({text:item.name, value: i})
			});
		},
		newItem(state, data) {
			state.new_item = data
		},
		setKey(state) {
			++state.key
		},
		setHuman(state, data) {
			state.humans = data
			state.humans.map(item => {
				state.humans_autocomplite.push({value: item.id, text: item.name})
			})
		},
		setNode(state, data) {
			data.active = true
			state.node = data

            // console.log('setNode - state.node = ', state.node);

			state.content = data.content
			state.curent_system.children
			function tree(res) {
				return res.map(item => {
						if (state.node.id == item.id) {
							return state.node
						} else {
							if (item.children) {
								tree(item.children)
							} else {
								return item
							}
						}
					})
				}
			tree(state.curent_system.children);
		},
		resetNode(state) {
			state.node = null
		},
		getSearchItems(state, data) {
			state.systems = data.map((item, index) => {
				return {text:item.name, value: index}
			})
		},
		getSearchs(state, data) {
			state.search_items = data.map(item => {
				return item.name
			})
		},
		setFiles(state, data) {
			state.files = data
		},
		setSystem(state, system){

		},
		addNode(state, data) {
			state.files = data
		},
		setContent(state, data) {
			state.content = data
		},
		setHumanData(state, data) {
			state.human_data = data
		},
		setImage(state, data) {
			state.image_url = data
		},
		setSearchHuman(state, data) {
			state.systems_copy = []
			state.systems_copy = data.data[0].children.map((item, index) => {
				return {text:item.name, value: item.id}
			})
		},
		setAnalyzers(state, data) {
			state.analyzers = [{ id: null, name: 'Любой' }];
			state.analyzers = state.analyzers.concat(data);
		}
	},
	actions: {
		setAttributeNode({ rootState }, data) {
			return new Promise((resolve, reject) => {
				axios.post(`${rootState.api}BodyTree/SetAttributeNode?nodeid=${data.model.id}&attrtype=${data.model.attributeType}`)
				.then(resp => {
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		copyNode({ commit, rootState }, data) {
			return new Promise((resolve, reject) => {
				axios.post(`${rootState.api}BodyTree/CopyBodyTreeSystems?sourceId=${data.sourceId}&newParentid=${data.newParentid}&newHumanid=${data.newHumanid}&withProperties=${data.withProperties}&withContent=${data.withContent}&withMediaFiles=${data.withMediaFiles}`)
				.then(resp => {
					commit('addNode', resp.data)
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		addNode({ commit, rootState }, data) {
			return new Promise((resolve, reject) => {
				axios.post(`${rootState.api}BodyTree/AddNode`, data)
				.then(resp => {
					commit('setNode', resp.data)
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		updateNode({ commit, rootState }, data) {
			return new Promise((resolve, reject) => {
				axios.post(`${rootState.api}BodyTree/UpdateNode`, data)
				.then(resp => {
					commit('setNode', resp.data)
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		UpdateNodeName({ commit, rootState }, data) {
			return new Promise((resolve, reject) => {
				axios.post(`${rootState.api}BodyTree/UpdateNodeName?nodeid=${data.id}&name=${data.newName}`)
				.then(resp => {
					commit('setNode', resp.data)
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		updateNodeContent({ commit, rootState }, data) {
			return new Promise((resolve, reject) => {
				axios.post(`${rootState.api}BodyTree/UpdateNodeContent`, data)
					.then(resp => {
						resolve(resp);
					})
					.catch(err => {
						reject(err);
					});
			});
		},
		deleteNode({ commit, rootState }, id) {
			return new Promise((resolve, reject) => {
				axios.post(`${rootState.api}BodyTree/DeleteNode?nodeid=${id}`)
				.then(resp => {
					commit('setNode', resp.data)
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		addItem({ commit, rootState },data) {
			return new Promise((resolve, reject) => {
				axios.post(`${rootState.api}BodyTree/AddItem`, data)
				.then(resp => {
					resolve(resp)
					commit('newItem', resp.data)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		searchHuman({ commit, rootState }, data) {
            // console.log('rootState', rootState.login.roles);
            
			return new Promise((resolve, reject) => {
				let userId = localStorage.getItem('userId') ? +localStorage.getItem('userId') : null,
					array = [];

				axios.post(`${rootState.api}BodyTree/SearchHuman`, data)
				.then(resp => {
					if(rootState.login.roles == 'Student') {
						resp.data.forEach(el => {
							if(el.id === 6) array.push(el)
						})
					} else {
                        array = resp.data;
                    }

					commit('setHuman', array)
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		updateItem({ commit, rootState }, data) {
			return new Promise((resolve, reject) => {
				axios.post(`${rootState.api}BodyTree/UpdateItem`, data)
				.then(resp => {
					commit('getAllMutation', resp.data)
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		deleteItem({ rootState }, data) {
			return new Promise((resolve, reject) => {
				axios.post(`${rootState.api}BodyTree/DeleteItem?itemid=${data.id}&itemtype=${data.itemType}`)
				.then(resp => {
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		addMediaFile({ commit, rootState }, data) {
			return new Promise((resolve, reject) => {
				const fileids = data.fileids.length ? data.fileids.map(item => {
					return `&fileids=${item}`
				}).join('') : ''
				axios.post(`${rootState.api}BodyTree/AddMediaFile?nodeid=${data.nodeid}${fileids}`)
				.then(resp => {
					commit('setFiles', resp.data)
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		removeMediaFile({ commit, rootState }, data) {
			return new Promise((resolve, reject) => {
				axios.post(`${rootState.api}BodyTree/RemoveMediaFile?nodeid=${data.nodeid}&fileid=${data.fileid}`)
				.then(resp => {
					commit('setFiles', resp.data)
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		getTreeView({ commit, rootState }, id) {
			return new Promise((resolve, reject) => {
				axios.get(`${rootState.api}BodyTree/GetTreeView?humanid=${id}`)
				.then(resp => {
					commit('setCurentTree', resp.data)
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		getNode({ commit, rootState }, data) {
            commit('changeLoadRedactor', true);
			return new Promise((resolve, reject) => {
				axios.get(`${rootState.api}BodyTree/GetNode?nodeid=${data.id}&withMediaFiles=${data.media}`)
				.then(resp => {
					resolve(resp)
					commit('setNode', resp.data)
                    commit('changeLoadRedactor', false);
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		getNodesByType({ commit, rootState }, file) {
			return new Promise((resolve, reject) => {
				axios.get(`${rootState.api}BodyTree/GetNodesByType?humanid=${file.humanid}&itemtype=${file.itemtype}`)
				.then(resp => {
					commit('getAllMutation', resp.data)
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		getMediaFilesForHuman({ commit, rootState }, file) {
			return new Promise((resolve, reject) => {
				axios.get(`${rootState.api}BodyTree/GetMediaFilesForHuman?humanid=${file.humanid}&MediaType=${file.mediaType}`)
				.then(resp => {
					commit('getAllMutation', resp.data)
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		searchItems({ commit, rootState }, file) {
			return new Promise((resolve, reject) => {
				const text = file.text ? `q=${file.text}` : ''
				axios.get(`${rootState.api}BodyTree/SearchItems?${text}&itemtype=${file.itemtype}`)
				.then(resp => {
					commit('getSearchItems', resp.data)
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		searchItemsData({ commit, rootState }, file) {
			return new Promise((resolve, reject) => {
				const text = file.text ? `q=${file.text}` : ''
				axios.get(`${rootState.api}BodyTree/SearchItems?${text}&itemtype=${file.itemtype}`)
				.then(resp => {
					commit('getSearchs', resp.data)
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		getHumanById({ commit, rootState }, id) {
			return new Promise((resolve, reject) => {
				axios.post(`${rootState.api}BodyTree/GetHumanById?humanid=${id}`)
				.then(resp => {
					commit('setHumanData', resp.data)
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		uploadNodeImage({ commit, rootState }, image) {
			return new Promise((resolve, reject) => {
				const formData = new FormData()
				formData.append('File', image)
				axios.post(`${rootState.api}BodyTree/UploadNodeImage`, formData, { 'Content-Type': 'multipart/form-data' })
				.then(resp => {
					commit('setImage', resp.data)
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		getUpdateNewSystem({ commit, rootState }, id) {
			return new Promise((resolve, reject) => {
				const humanId = id ? `?humanid=${id}` : ''
				axios.get(`${rootState.api}BodyTree/GetTree${humanId}`)
				.then(resp => {
					commit('setSearchHuman', resp)
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		getAnalyzers({ commit, rootState }) {
			return new Promise((resolve, reject) => {
				axios.get(`${rootState.api}BodyTree/GetAnalyzers`)
					.then(response => {
						commit('setAnalyzers', response.data)
						resolve(response)
					})
					.catch(err => {
						reject(err)
					})
			})
		}
	}
};
